"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.navigatedToInternalPage = void 0;
var typesafe_actions_1 = require("typesafe-actions");
exports.navigatedToInternalPage = (0, typesafe_actions_1.createStandardAction)('@window/NAVIGATED_TO_INTERNAL_PAGE')();